import { CATEGORIES } from '@kijiji/category'
import { type TFunction } from 'i18next'
import qs from 'query-string'

/**
 * Change category of the URL
 */
export const changeCategoryOfUrl = (
  href: string,
  name: string,
  id: number,
  t: TFunction,
  seoParam?: string
): string => {
  const url = new URL(href)
  const pathname = url.pathname

  // Separate segments and remove any empty ones
  const segments = pathname.split('/')

  const lastIndex = segments.length - 1
  const categoryIndex = 1

  // Change the category parameter of the URL (b-cars-trucks)
  // Use provided seoParam or fall back to translation
  const categoryParam = seoParam || t(`srp:search_by_category.${name}.seo_param`)

  if (categoryParam) {
    segments[categoryIndex] = categoryParam
  }

  // Change the parameter "c" in the URL
  segments[lastIndex] = segments[lastIndex].replace(
    `c${CATEGORIES.CARS_AND_TRUCKS_CATEGORY_ID}`,
    `c${id}`
  )

  const { query } = qs.parseUrl(url.href)

  url.pathname = segments.join('/')
  return qs.stringifyUrl({ url: url.href, query })
}
